import RemoveFromBasketRequestModel from '../../../generated/types/model/request/RemoveFromBasketRequestModel';

export default class RemoveFromBasketRequestViewModel extends RemoveFromBasketRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
